import type { GradeCategory, GradeReport, MatchPhase, Weather, TimeOfDay } from '../core/contracts';

export { formatCompact } from '../meta/share';

export const CATEGORY_LABELS: Record<GradeCategory, string> = {
  coverage: 'COVERAGE', shot_choice: 'SHOT CHOICE', pacing: 'PACING', continuity: 'CONTINUITY',
  replays: 'REPLAYS', graphics: 'GRAPHICS', booth: 'BOOTH',
};

export const CATEGORY_HINTS: Record<GradeCategory, string> = {
  coverage: 'Keep the action on PGM. Miss a key moment and it shows.',
  shot_choice: 'Right size for the moment: tight on the scorer, wide in open play.',
  pacing: 'Not too jumpy, not too static. Hold wides 6–25s.',
  continuity: 'No REVERSE cuts during live play. No jump cuts.',
  replays: 'Replay big moments at the next stoppage. Never over live danger.',
  graphics: 'Scorebug on. Lower thirds on time. No clutter during attacks.',
  booth: 'Give the commentators what they ask for, before the bar runs out.',
};

export const PHASE_LABELS: Record<MatchPhase, string> = {
  pre_match: 'PRE-MATCH', kickoff: 'KICK-OFF', open_play: 'LIVE PLAY', stoppage: 'STOPPAGE',
  set_piece: 'SET PIECE', goal_celebration: 'GOAL!', half_time: 'HALF-TIME', full_time: 'FULL-TIME',
};

export const WEATHER_LABELS: Record<Weather, string> = { clear: 'CLEAR', overcast: 'OVERCAST', rain: 'RAIN', snow: 'SNOW', fog: 'FOG' };
export const TIME_LABELS: Record<TimeOfDay, string> = { afternoon: 'AFTERNOON', golden_hour: 'GOLDEN HOUR', night: 'NIGHT' };

export const LETTER_COLORS: Record<GradeReport['letter'], string> = {
  S: '#c7a6ff', A: '#ffcf4a', B: '#19d36b', C: '#5cc8ff', D: '#ff8a3d', F: '#ff2d2d',
};

/** Seconds → "MM:SS" (minutes can exceed 99 → still fine for display). */
export function clockText(sec: number): string {
  const s = Math.max(0, Math.floor(sec));
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

/** Live mult display derived from streak. Mirrors grading's rhythm multiplier (×1..×4). */
export function streakMultiplier(streak: number): { mult: number; progress: number } {
  const mult = Math.min(4, 1 + Math.floor(streak / 5));
  return { mult, progress: mult >= 4 ? 1 : (streak % 5) / 5 };
}

export function barColor(v: number): string {
  return v >= 75 ? 'var(--tally-green)' : v >= 50 ? 'var(--amber)' : 'var(--tally-red)';
}

export function withCommas(n: number): string {
  return Math.round(n).toLocaleString('en-GB');
}
